import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'

const app = createApp(App)

// Global scroll-reveal directive for sub-headlines and section content
app.directive('scroll-reveal', {
  mounted(el, binding) {
    const delay = binding.value?.delay || 0
    el.style.opacity = '0'
    el.style.transform = 'translateY(24px)'
    el.style.transition = `opacity 0.7s cubic-bezier(0.16,1,0.3,1) ${delay}s, transform 0.7s cubic-bezier(0.16,1,0.3,1) ${delay}s`
    el.style.willChange = 'transform, opacity'

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.style.opacity = '1'
          el.style.transform = 'translateY(0)'
          observer.disconnect()
        }
      },
      { threshold: 0.15 }
    )
    observer.observe(el)
    el._scrollRevealObserver = observer
  },
  unmounted(el) {
    if (el._scrollRevealObserver) el._scrollRevealObserver.disconnect()
  }
})

app.use(i18n).use(router).mount('#app')

// Register service worker for PWA offline caching
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {
      // Service worker registration failed silently
    })
  })
}
